import React, {memo} from "react";
import {CustomSocket} from "./CustomSocket";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {COLLAPSED_NESTED_NODE_HEIGHT, NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledNestedNodeDiv = styled.div`
  height: ${props => props.$isNodeCollapsed ? COLLAPSED_NESTED_NODE_HEIGHT : "auto"};
  display: flex;
  flex-direction: column;
  padding: 16px 0px;
`;

const StyledRemoveButtonContainerDiv = styled.div`
  margin-left: auto;
  position: relative;
`;

const StyledRemoveButtonWrapperDiv = styled.div`
  width: 100%;
  padding: 0;
  position: absolute;
  top: -36px;
  right: 38px;
`;

const StyledAvatarControlsSocketContainerDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StyledAvatarControlsContainerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledAnimationFileControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  width: 100%;
  > div {
    width: 100% !important;
    flex: 1 !important;
  }
`;

const StyledSocketContainerDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  width: 0px;
`;

const Avatar = ({node, controls, output, bindSocket, bindControl, isNodeCollapsed}) => {

    if (controls.length === 0) return null;

    const isAvatarOwningOutput = SequenceComponentHelper.isAvatarOwningOutput(node);
    const avatarUUID = output.key.split("_")[0];
    const removeControl = controls.find(control => control.key.includes(SequenceComponentHelper.getAvatarRemoveButtonKey(avatarUUID)));
    const animationFileControl = controls.find(control => control.key.includes(SequenceComponentHelper.getAvatarAnimationFileKey(avatarUUID)));

    return (
        <>

            {/** NESTED NODE - AVATAR */}
            <StyledNestedNodeDiv $isNodeCollapsed={isNodeCollapsed}>

                {/** REMOVE BTN */}
                {!isNodeCollapsed &&
                    <StyledRemoveButtonContainerDiv>
                        <StyledRemoveButtonWrapperDiv>
                            <Control key={removeControl.key} control={removeControl} innerRef={bindControl}/>
                        </StyledRemoveButtonWrapperDiv>
                    </StyledRemoveButtonContainerDiv>
                }

                {/** AVATAR CONTROLS & SOCKET */}
                <StyledAvatarControlsSocketContainerDiv>

                    {/** AVATAR CONTROLS */}
                    <StyledAvatarControlsContainerDiv>
                        <StyledAnimationFileControlContainerDiv>
                            <Control key={animationFileControl.key} control={animationFileControl} innerRef={bindControl}/>
                        </StyledAnimationFileControlContainerDiv>
                    </StyledAvatarControlsContainerDiv>

                    {/** SOCKET */}
                    <StyledSocketContainerDiv>
                        {output && isAvatarOwningOutput &&
                            <CustomSocket type="output" socket={output.socket} io={output} innerRef={bindSocket}/>
                        }
                    </StyledSocketContainerDiv>
                </StyledAvatarControlsSocketContainerDiv>
            </StyledNestedNodeDiv>
        </>
    );
}

export default memo(Avatar);
